<template>
  <div>
    <v-list-item-title class="base-table__table-name text-h5">
      <div>
        <v-breadcrumbs :items="itensBreadcrumb" />
      </div>
    </v-list-item-title>
    <div class="pt-4">
      <list-files @updateBreadcrumb="updateBreadcrumb" />
    </div>
  </div>
</template>

<script>

import ListFiles from '@/views/modulos/ajuda/components/listFiles.vue'

export default {
  name: 'Help',
  components: {
    ListFiles,
  },
  data() {
    return {
      itensBreadcrumb: [],
    }
  },
  mounted() {
    this.setItensBreadcrumb()
  },
  methods: {
    capitalizeFirstLetter(string) {
      if (!string) return ''
      return string?.charAt(0)?.toUpperCase() + string.slice(1).replace(/-/g, ' ');
    },
    setItensBreadcrumb() {
      this.itensBreadcrumb = [
        {
          text: 'Ajuda',
          disabled: false,
          href: '/ajuda'
        },
      ]
      this.$route?.params?.moduleName?.split('\\')?.forEach(element => {
        this.itensBreadcrumb.push({
          text: this.capitalizeFirstLetter(element),
          disabled: false,
        })
      });
    },
    updateBreadcrumb(pastas) {
      this.itensBreadcrumb = [
        {
          text: 'Ajuda',
          disabled: false,
          // href: '/ajuda'
        },
      ]
      pastas?.forEach(nome => {
        this.itensBreadcrumb.push({
          text: this.capitalizeFirstLetter(nome),
          disabled: false,
        })
      })
      // const path = item.nomePasta?.split('\\').filter(i => i.length && i != 'ajuda')
      // path?.forEach(element => {
      //   this.itensBreadcrumb.push({
      //     text: this.capitalizeFirstLetter(element),
      //     disabled: false,
      //   })
      // })
    }
  },
};
</script>

<style lang="scss">
  ul {
    padding: 0px !important;
  }
  .v-breadcrumbs__item {
    color: #344054 !important;
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
</style>
